import React from 'react';
import PropTypes from 'prop-types';
import {Button, Form, FormControl, FormGroup, OverlayTrigger, Tooltip} from 'react-bootstrap';

class RandomAssessmentButton extends React.Component {


  render() {
    const tooltip = ( <Tooltip id="tooltip"> WARNING: Do not enter future dates! Do not enter junk! This form is NOT validated and throws no errors! </Tooltip> );

    return(
      <Form onSubmit={this.props.onSave}>
        <FormGroup>
          <FormControl name='month' type='text' placeholder='*month' onChange={this.props.onChange}/>
          <FormControl name='day' type='text' placeholder='*day' onChange={this.props.onChange}/>
          <FormControl name='year' type='text' placeholder='*year' onChange={this.props.onChange}/>
          {this.props.groupForm && <FormControl name='takers' type='number' placeholder='number of survey takers (< 50)' onChange={this.props.onChange}/>}
        </FormGroup>
        <OverlayTrigger placement="bottom" overlay={tooltip}>
          <Button type='submit' className='mr1 mb1 mt0'>Add Random {this.props.groupForm ? 'Group' : 'Coach'} Assessment</Button>
        </OverlayTrigger>
      </Form>
    );
  }

}

RandomAssessmentButton.propTypes = {
  onSave: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default RandomAssessmentButton;




// WEBPACK FOOTER //
// ./src/components/teams/RandomAssessmentButton.js